import React from "react"
import { socialLinks } from "../../config"
import styles from "./index.module.css"

export default () => (
    <div style={{
        backgroundImage: "url('/illustrations/footer.svg')",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        height: "250px"
    }} className="row no-gutters align-items-end">
        <div className="row no-gutters w-100 justify-content-center flex-md-row-reverse mb-2 align-items-center">
            <div className={["col-12 col-md-5 text-center text-md-right", styles.footerBackground].join(" ")}>
                <ul className="col-12">
                    {
                        socialLinks.map((socialLink, index) => (
                            <li key={index}>
                                <a href={socialLink.url} aria-label={socialLink.name} target="_blank" rel="noopener noreferrer">
                                    <i className={socialLink.icon}></i>
                                </a>
                            </li>
                        ))
                    }
                </ul>
            </div>
            <div className="col-12 col-md-5 text-center text-md-left">
                © All rights are reserved, {new Date().getFullYear()},&nbsp;
                <a href="mailto:rsvedpathak@gmail.com" style={{ textDecoration: "underline" }}>rsvedpathak@gmail.com</a>
            </div>
        </div>
    </div>
)